import english from "./en";
import russia  from "./ru";

const translation = {
    en : english,
    ru : russia,
}

export default translation;